var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnbChainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2818 0.783688L12.2836 0.784116C17.3805 2.03659 20.4821 7.20274 19.2176 12.2926C17.9499 17.379 12.7982 20.4846 7.70287 19.2162C2.6164 17.9444 -0.48371 12.7927 0.783729 7.70742C2.0516 2.62042 7.2003 -0.484358 12.2818 0.783688Z",
    fill: "black",
    stroke: "#FCD535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8254 9.51162L13.8177 7.84709H13.8237L12.4099 7.01482L9.98722 8.44329L7.57918 7.01482L6.16624 7.84709V9.51162L8.58892 10.9332V13.7832L9.99583 14.6077L11.4027 13.7832V10.9332L13.8254 9.51162Z",
    fill: "#FCD535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98808 2.75098L6.16538 5.00481L7.57229 5.83707L9.98808 4.40861L12.4108 5.83707L13.8177 5.00481L9.98808 2.75098Z",
    fill: "#FCD535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15588 12.944L5.14812 10.1009L3.74207 9.2695V13.7841L7.57167 16.0301V14.3656L5.15588 12.944Z",
    fill: "#FCD535"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14812 8.91454V7.25776L6.56193 6.4255L5.14812 5.59324L3.74121 6.4255V8.08227L5.14812 8.91454Z",
    fill: "#FCD535"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98745 5.59324L8.58054 6.4255L9.98745 7.25776L11.4013 6.4255L9.98745 5.59324Z",
    fill: "#FCD535"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57229 11.5225L6.16538 10.6902V12.3547L7.57229 13.1792V11.5225Z",
    fill: "#FCD535"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98808 15.7941L8.58117 14.9618V16.6186L9.98808 17.4509L11.4019 16.6186V14.9618L9.98808 15.7941Z",
    fill: "#FCD535"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8265 5.59324L13.4196 6.4255L14.8265 7.25776V8.91454L16.2404 8.08227V6.4255L14.8265 5.59324Z",
    fill: "#FCD535"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2412 9.26864L14.8343 10.1009L14.8265 12.944L12.4116 14.3648V16.0293L16.2412 13.7832V9.26864Z",
    fill: "#FCD535"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.818 12.3547L12.4111 13.1792V11.5224L13.818 10.6902V12.3547Z",
    fill: "#FCD535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbChainLogo);
export default __webpack_public_path__ + "static/media/bnb-chain-logo.c9dba79df8e4870677dcec43dcfbfc18.svg";
export { ForwardRef as ReactComponent };